import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import CustomerTopbar from "../../features/manageCustomers/topbar";
import BannerList from "../../features/banner/BannerList";
import DiscountList from "../../features/discount/DiscountList";
import { Box, Button, Tabs, Tab } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from "@mui/icons-material/Download";
import SearchBar from "../../components/SearchBar";
import { ENUM_ROUTES } from "../../RoutesEnum";
import { useState } from "react";
import { isValidInput } from "../../utils/validations";
import { useLazyDiscountExportQuery } from "../../services/discount";
import { showError } from "../../constants/toasts";

const ManageDiscount = () => {
  const navigate = useNavigate();
  const [exportApi] = useLazyDiscountExportQuery();
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [valueTabs, setValueTabs] = useState(0);
  const selectedType = valueTabs === 0 ? "VENUE" : "STORAGE";
  const handleChangeTabs = (_: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const exportCsv = async () => {
    try {
      const response = await exportApi({}).unwrap();
      console.log(response, "response");

      if (response?.statusCode === 200) {
      }
    } catch (error: any) {
      console.log(error, "error");

      showError(error?.data?.message || "");
    }
  };

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Discount</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage
          Discount
        </p>
      </div>
      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <Box className="custom_tabs1" sx={{ width: "100%" }}>
              <Tabs
                value={valueTabs}
                onChange={handleChangeTabs}
                aria-label="discount type tabs"
                className="custom_tabs_links"
              >
                <Tab label="Venue" />
                <Tab label="Storage" />
              </Tabs>
            </Box>
            <Box className="search_box">
              <SearchBar
                placeholder="Search..."
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                value={searchTerm}
                onCross={() => setSearchTerm("")}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
            </Box>
          </div>
          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => navigate(ENUM_ROUTES.ADD_DISCOUNT)}
            >
              <AddIcon /> Add
            </Button>
            <Button onClick={exportCsv} className="btn btn_grey">
              <DownloadIcon /> Export
            </Button>
          </div>
        </div>
        <DiscountList
          searchTerm={searchTerm}
          setDebouncedSearchTerm={setDebouncedSearchTerm}
          setSearchTerm={setSearchTerm}
          selectedType={selectedType}
        />
      </div>
    </MainContainer>
  );
};

export default ManageDiscount;
